import React from "react";
import PriceBox from "./PriceBox";

function ServicePrice() {
  return (
    <>
      <section className="pricing-plan sec-mar">
        <div className="container">

          {/* HEADER */}
          <div className="row justify-content-between align-items-center">
            <div className="col-12 col-lg-6 col-xl-5 or2">
              <ul className="nav nav-pills mb-3" role="tablist">
                <li className="nav-item">
                  <button className="nav-link active" data-bs-toggle="pill" data-bs-target="#basic">
                    Packages
                  </button>
                </li>
                <li className="nav-item">
                  <button className="nav-link" data-bs-toggle="pill" data-bs-target="#advanced">
                    Advanced Solutions
                  </button>
                </li>
              </ul>
            </div>

            <div className="col-12 col-lg-6 col-xl-5 or1">
              <div className="title black">
                <span>Pricing Plan</span>
                <h2>Flexible Pricing for Every Stage of Your Business</h2>
              </div>
            </div>
          </div>

          {/* TAB CONTENT */}
          <div className="tab-content">

            {/* ================= BASIC PACKAGES ================= */}
            <div className="tab-pane fade show active" id="basic">
              <div className="row g-4">

                <PriceBox
                  month="project"
                  cartTitle="Starter"
                  cartSubtitle="For small businesses"
                  price="500"
                  featurePages="5-7 Page Website"
                  featurePpc="Responsive Design"
                  seo="Basic SEO Setup"
                  facebookComplaigns="Contact Form Integration"
                  videoCompligns="1 Month Support"
                />

                <PriceBox
                  month="project"
                  cartTitle="Growth"
                  cartSubtitle="Best for startups"
                  price="1050"
                  featurePages="10-15 Page Website / App"
                  featurePpc="UI/UX Design Included"
                  seo="Performance Optimization"
                  facebookComplaigns="API Integration"
                  videoCompligns="3 Months Support"
                />

                <PriceBox
                  month="project"
                  cartTitle="Enterprise"
                  cartSubtitle="For scaling businesses"
                  price="2999"
                  featurePages="Custom Web/App/SaaS"
                  featurePpc="Advanced Features & Dashboards"
                  seo="AI / Automation Integration"
                  facebookComplaigns="Cloud Deployment"
                  videoCompligns="6 Months Support"
                />

              </div>
            </div>

            {/* ================= ADVANCED SOLUTIONS ================= */}
            <div className="tab-pane fade" id="advanced">
              <div className="row g-4">

                <PriceBox
                  month="solution"
                  cartTitle="AI Solutions"
                  cartSubtitle="Automation & Intelligence"
                  price="Custom"
                  featurePages="Chatbots / AI Tools"
                  featurePpc="Workflow Automation"
                  seo="Data Processing Systems"
                  facebookComplaigns="Custom AI Models"
                  videoCompligns="Ongoing Support"
                />

                <PriceBox
                  month="solution"
                  cartTitle="SaaS Development"
                  cartSubtitle="Scalable Platforms"
                  price="Custom"
                  featurePages="Multi-user System"
                  featurePpc="Admin Dashboard"
                  seo="Subscription & Billing"
                  facebookComplaigns="Cloud Infrastructure"
                  videoCompligns="Maintenance & Updates"
                />

                <PriceBox
                  month="solution"
                  cartTitle="Game & AR/VR"
                  cartSubtitle="Interactive Experience"
                  price="Custom"
                  featurePages="Game Development"
                  featurePpc="AR/VR Integration"
                  seo="3D Assets & UI"
                  facebookComplaigns="Performance Optimization"
                  videoCompligns="Deployment Support"
                />

              </div>
            </div>

          </div>

          {/* FOOTNOTE */}
          <div style={{ marginTop: "20px", fontSize: "14px", textAlign: "center" }}>
            *Pricing may vary based on project requirements.
          </div>

        </div>
      </section>
    </>
  );
}

export default ServicePrice;